var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchable-fuzzy-list",class:{ scrollable: _vm.scrollable }},[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":_vm.$t('Search'),"single-line":"","hide-details":""},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}}),_vm._t("default",null,{"items":_vm.items})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }